<template>
    <v-dialog v-model="show_payment_message" persistent max-width="600">
        <v-card class="rounded-xl pa-8">
            <v-card-title class="headline title-color justify-center">Solicitar una reinstalación</v-card-title>
            <v-card-text class="pa-0 ma-0">
                <v-row class="pb-3" v-if="screen_data_2.show_file_field">
                    <v-col>
                        <p class="ma-0">El importe para solicitar una nueva instalación es de 40€ más IVA</p>
                    </v-col>
                    <v-col cols="12">
                        <p class="ma-0">
                            Cuenta de Inmatic:
                            <span class="font-weight-bold">
                                BANCO SABADELL IBAN: ES04 0081 0400 1100 0123 0926
                            </span>
                        </p>
                    </v-col>
                </v-row>
                <v-row v-else>
                    <v-col>
                        <p class="ma-0">¿Deseas utilizar tu reinstalación gratuita?</p>
                    </v-col>
                </v-row>
                <div class="d-flex flex-column" >
                    <v-file-input 
                        v-if="payment_file != 'close'"
                        v-model="payment_file"
                        :rules="[validationRules.file_required]"
                        outlined
                        prepend-icon=""
                        prepend-inner-icon="mdi-paperclip"
                        name="uploader"
                        label="Adjuntar justificante de pago"
                        class="file-input--outlined rounded-lg pb-2"
                        hide-details
                        dense
                        v-show="screen_data_2.show_file_field"
                    />
                </div>
            </v-card-text>
            <v-card-actions class="mt-8 mb-0 mx-0 pa-0  d-flex justify-space-between">
                <app-btn v-for="(action, index) in actions" 
                    v-bind:key="index" 
                    large
                    outlined
                    @click="doEmit(action['emit'])" :color="action['primary'] ? 'white justify-start' : 'primary'"
                    :class="action['primary'] ? 'primary-background justify-end' : 'primary-border'"
                    :loading="is_loading"
                >
                    {{ action['action_text'] }}
                </app-btn>
            </v-card-actions>

        </v-card>
    </v-dialog>
</template>

<script>
import AppBtn from '@/components/layout/AppBtn.vue'
import contracts from '@/store/modules/contracts';


export default {
    name: 'PaymentInstallationPopup',

    components: {
        AppBtn,
    },
    props: {
        show_payment_message: {
            type: Boolean,
            required: true
        },
        persistent: {
            type: Boolean,
            required: false,
            default: true,
        },
        screen_data_2: {
            type: Object,
            required: true
        },
        actions: {
            type: Array,
            required: false,
            default: function () {
                return [
                    { 'action_text': 'Cancelar', 'emit': 'close-message-without-file', 'prin': true, 'primary': false },
                    { 'action_text': 'Confirmar', 'emit': 'close-message', 'prin': true, 'primary': true }
                ];
            }
        },
    },
    data() {
        return {
            validationRules: {
                required: v => (v.toString() != 'false') || 'Campo obligatorio',
                file_required: v => !!v || (v && v.size > 0) || 'Campo obligatorio',
                select_required: (v) => !!v || "Campo obligatorio",
            },
            payment_file: null,
            is_loading: false,
        }
    },
    methods: {
        async doEmit(emit) {
            this.is_loading = true
            try {
                if (emit === 'close-message-without-file') {
                    this.payment_file = 'close';
                    await this.$emit('close-message', this.payment_file);
                } else {
                    await this.$emit(emit, this.payment_file);
                }
                this.is_loading = this.show_payment_message;
                if (!this.is_loading){
                    this.payment_file = null
                }
            } catch (error) {
                console.error("Error al enviar el archivo:", error);
            }
        }
    }
}
</script>


<style lang="scss" scoped>
.primary-background {
    background-color: var(--v-primary-base);
}

.primary-border {
    border-color: var(--v-primary-base) !important;
}

.table-head {
    border-left-style: solid;
    border-right-style: solid;
    border-color: #D9D9D9;
    border-width: thin;
}

.app-confirm-modal__body,
.app-confirm-modal__question {
    font-family: 'Roboto';
    font-style: normal;
    font-size: 20px;
    line-height: 23px;
    text-transform: none;
    letter-spacing: normal;
    font-weight: bold;
}

.app-confirm-modal__body {
    font-weight: 400;
}
</style>